import type { Agent, AgentCategory } from "@/types/agent";

export type AgentCategoryId = AgentCategory | "all";

export const agentCategories: { id: AgentCategoryId; label: string }[] = [
  { id: "all", label: "全部" },
  { id: "tax", label: "报税" },
  { id: "finance", label: "财务" },
  { id: "logistics", label: "货运" },
  { id: "other", label: "其他" },
];

export const mockAgents: Agent[] = [
  {
    id: "default",
    name: "智能体广场",
    description:
      "匹配与决策智能体引擎系统的默认智能助手，为用户提供智能对话、订单查询、货物跟踪、商贸分析等全方位服务。",
    category: "other",
    icon: "Bot",
    iconColor: "text-blue-600",
    iconBgColor: "bg-blue-100",
    userCount: 9999,
    isDefault: true,
    features: ["智能对话", "订单查询", "货物跟踪", "商贸分析"],
  },
  {
    id: "tax-assistant",
    name: "智能报税助手",
    description:
      "自动处理税务申报，智能识别发票信息，提供增值税、企业所得税、个人所得税等税务咨询服务。",
    category: "tax",
    icon: "Calculator",
    iconColor: "text-blue-600",
    iconBgColor: "bg-blue-100",
    userCount: 1250,
    isDefault: false,
    features: ["增值税申报", "企业所得税", "个税申报", "发票识别"],
  },
  {
    id: "finance-analyst",
    name: "财务分析师",
    description:
      "提供专业的财务数据分析服务，包括财务报表分析、预算执行情况、成本效益分析等。",
    category: "finance",
    icon: "TrendingUp",
    iconColor: "text-green-600",
    iconBgColor: "bg-green-100",
    userCount: 890,
    isDefault: false,
    features: ["财务报表分析", "预算分析", "成本效益分析", "财务预测"],
  },
  {
    id: "cost-expert",
    name: "成本核算专家",
    description:
      "专注于企业成本核算与分析，提供运输成本、仓储成本、人力成本等全方位成本优化建议。",
    category: "finance",
    icon: "DollarSign",
    iconColor: "text-orange-600",
    iconBgColor: "bg-orange-100",
    userCount: 756,
    isDefault: false,
    features: ["运输成本核算", "仓储成本分析", "人力成本优化", "成本报表"],
  },
  {
    id: "dispatch-assistant",
    name: "货运调度员",
    description:
      "智能货运调度助手，帮助优化运输路线、管理车辆调度、提供配送方案建议。",
    category: "logistics",
    icon: "Truck",
    iconColor: "text-purple-600",
    iconBgColor: "bg-purple-100",
    userCount: 2340,
    isDefault: false,
    features: ["智能调度", "路线优化", "车辆管理", "配送方案"],
  },
  {
    id: "waybill-manager",
    name: "运单管理助手",
    description:
      "专业的运单管理助手，支持运单创建、追踪、修改和查询，提供运单状态实时更新。",
    category: "logistics",
    icon: "FileText",
    iconColor: "text-indigo-600",
    iconBgColor: "bg-indigo-100",
    userCount: 1876,
    isDefault: false,
    features: ["运单创建", "运单追踪", "运单修改", "状态查询"],
  },
  {
    id: "customer-service",
    name: "智能客服助手",
    description:
      "提供7x24小时智能客服服务，解答客户咨询、处理投诉建议、提供业务办理指导。",
    category: "other",
    icon: "MessageCircle",
    iconColor: "text-pink-600",
    iconBgColor: "bg-pink-100",
    userCount: 3210,
    isDefault: false,
    features: ["智能问答", "投诉处理", "业务咨询", "服务评价"],
  },
];

export interface ContextTemplate {
  id: string;
  label: string;
  content: string;
}

export const contextTemplates: ContextTemplate[] = [
  {
    id: "logistics",
    label: "物流企业报税",
    content:
      "我是一家物流企业，主要从事货物运输和仓储服务。我们有大量的运输车辆，需要申报增值税和企业所得税。",
  },
  {
    id: "retail",
    label: "商贸企业财务",
    content:
      "我是一家商贸公司，主要从事商品销售。我们需要分析销售数据、管理库存、处理应收账款。",
  },
  {
    id: "shipping",
    label: "货运调度优化",
    content:
      "我负责公司的货运调度工作，需要优化配送路线、管理车队、降低运输成本。",
  },
  {
    id: "customs",
    label: "报关报税",
    content:
      "我需要处理进出口报关业务，了解关税政策、办理退税手续、协调海关查验。",
  },
  {
    id: "warehouse",
    label: "仓储管理",
    content:
      "我负责仓库管理工作，需要管理库存、处理出入库、协调配送安排。",
  },
  {
    id: "custom",
    label: "自定义",
    content: "",
  },
];

export interface ResponseStyleOption {
  id: "concise" | "detailed" | "professional";
  label: string;
  description: string;
}

export const responseStyleOptions: ResponseStyleOption[] = [
  {
    id: "concise",
    label: "简洁风格",
    description: "直接给出结论和关键信息，简洁明了",
  },
  {
    id: "detailed",
    label: "详细风格",
    description: "提供完整的分析和说明，详尽全面",
  },
  {
    id: "professional",
    label: "专业风格",
    description: "使用行业术语和专业表达，权威可靠",
  },
];
